import React from 'react';
import InfoCard from './InfoCard';
import styles from '../TripTrackingV2.module.scss';

const CommentsCard = ({ comments }) => {
  if (!comments) return null;
  return (
    <InfoCard title="Comments / additional information">
      <div className={styles.comments}>{comments}</div>
    </InfoCard>
  );
};

export default CommentsCard;
